module.exports = __webpack_public_path__ + "ae9d05ea9289a8b2869e9e9dc725eee7.svg";